import React, { useEffect, useRef } from "react";
import "./style.scss";
import parse from "html-react-parser";

export function ResponseArea(props) {
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current.value === null || inputRef.current.value === "") {
      inputRef.current.value = props.answer;
    }
  }, []);

  const updateResponseArea = () => {
    const value = inputRef.current.value;
    props.onValueChange(value);
  };

  const wrapperClass = () => {
    const classList = [props.className, "responseArea"];
    return classList.join(" ");
  };

  return (
    <>
      <div className={wrapperClass()}>
        <textarea
          id={props.id}
          rows="4"
          className="textarea-input"
          onInput={(e) => updateResponseArea(e)}
          disabled={props.disabled}
          placeholder="Answer here."
          ref={inputRef}
        />
      </div>
      {props.feedback && props.renderFeedback && (
        <div
          role="alert"
          aria-live="polite"
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "8px",
            background: "#F5F7F9",
            border: "1px solid #336589",
            borderRadius: "5px",
            justifyContent: "center",
            margin: "8px 0",
          }}
        >
          <p
            style={{ flex: 1, margin: "0 0 0 8px", whiteSpace: "pre-wrap" }}
            className={"OpenEndedFeedback"}
          >
            {parse(props.feedback)}
          </p>
        </div>
      )}
    </>
  );
}
